import styled from 'styled-components'

const GamesStyle = styled.div`
  min-height: 25vh;
  width: 90vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  overflow-y: auto;
  ${'' /* overflow-x: scroll; */}
  margin-top: 7vh;
  margin-bottom: 6.5vh;
  position: relative;
  justify-content: space-around;

  img {
    margin: 0 1.5rem;
    width: 12rem;
  }

  .arrow {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 1.5rem;
    transform: rotate(180deg);
    animation: moveBackAndForth 2s linear infinite;
  }

  @keyframes moveBackAndForth {
    0% {
      right: 0;
    }
    50% {
      right: 7px;
    }
    100% {
      right: 0;
    }
  }

  @media (min-width: 768px) {
    .arrow {
      display: none;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100vw;
    ${'' /* flex-direction: column; */}

    margin-top: 7vh;
    margin-bottom: 6vh;
    img {
      margin: 1.5rem 0.25rem;
    }
  }
`

export default GamesStyle
